import React from 'react';
import ClaimStatusBadge from './ClaimStatusBadge';
import { ClaimsService } from '../../../services/billing/claims.service';
import { SUBMISSION_METHOD_LABELS } from '../../../dtos/billing/claims.dto';
import type { ClaimStatusHistoryEntry } from '../../../dtos/billing/claims.dto';

function formatDateTime(iso: string): string {
  const d = new Date(iso);
  return Number.isNaN(d.getTime())
    ? iso
    : d.toLocaleString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit' });
}

/** Per-claim status history (REQ-BIL-10), newest first. */
const ClaimStatusHistory: React.FC<{ history: ClaimStatusHistoryEntry[] }> = ({ history }) => {
  if (!history?.length) return <p className="text-sm text-slate-500">No status history.</p>;
  const sorted = [...history].sort((a, b) => String(b.changedAt).localeCompare(String(a.changedAt)));
  return (
    <ol className="space-y-3" aria-label="Status history">
      {sorted.map((entry, i) => (
        <li key={`${entry.changedAt}-${i}`} className="border-l-2 border-slate-200 pl-3">
          <div className="flex flex-wrap items-center gap-2">
            <ClaimStatusBadge status={entry.status} />
            <span className="text-xs text-slate-500">{formatDateTime(entry.changedAt)}</span>
          </div>
          <dl className="mt-1 grid grid-cols-[auto_1fr] gap-x-2 text-xs text-slate-600">
            {entry.date && (<><dt>Date</dt><dd>{ClaimsService.formatDate(entry.date)}</dd></>)}
            {entry.method && (<><dt>Method</dt><dd>{SUBMISSION_METHOD_LABELS[entry.method] || entry.method}</dd></>)}
            {entry.amount !== undefined && (<><dt>Amount</dt><dd>{ClaimsService.formatCurrency(entry.amount)}</dd></>)}
            {entry.payerClaimNumber && (<><dt>Payer claim #</dt><dd>{entry.payerClaimNumber}</dd></>)}
            {entry.reason && (<><dt>Reason</dt><dd>{entry.reason}</dd></>)}
          </dl>
          {(entry.note || entry.notes) && <p className="mt-1 text-xs italic text-slate-500">{entry.note || entry.notes}</p>}
        </li>
      ))}
    </ol>
  );
};

export default ClaimStatusHistory;
